import { ActivityTime } from './activity-time';
import { Role } from './role';
import { WorkingShift } from './calendar/working-shift';

export class WorkingHoursValidation {
  roleImagePath: any;
  constructor(
    public hash: string,
    public userHash: string,
    public userName: string,
    public userReference: string,
    public userWorkingShiftHash: string,
    public validationDay: number,
    public validated: boolean,
    public hasIncompleteData: boolean,
    public isShortDay: boolean,
    public activitiesTime: ActivityTime[],
    public totalTime: number,
    public roles: Role[],
    public workingShift: WorkingShift
  ) { }

  get userFullName() {
    return this.userName;
  }
}



// WEBPACK FOOTER //
// /var/www/borneo/prod/borneo_app/src/app/core/models/working-hours-validation.ts